import React from 'react';
import Login from "./login";
import ForgotPassword from './forgotPassword';
import './styles/index.css';

const AuthPage = ({ history }) => {
	let path = window.location.pathname;
	return (
		<>
			<div className="login-container d-flex flex-column flex-root">
				<div className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white" id="kt_login">
					<div className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat bgi-position-center p-10 p-lg-10"
						style={{ backgroundImage: `url("/Assets/background_2.jpg")` }}>
						<div className="d-flex flex-row-fluid flex-column justify-content-between">
							{/* <img onClick={() => history.push('/')} className="cursor-pointer flex-column-auto mt-5 pb-lg-0 pb-10 max-h-70px"
								alt="Logo" src={"/media/logos/logo-letter-1.png"} /> */}

							<div className="flex-column-fluid d-flex flex-column justify-content-center">
								<h3 className="font-size-h1 mb-5">
									Welcome to Aamer!
								</h3>
							</div>
						</div>
					</div>

					<div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
						<div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
							{path === '/' ? <Login history={history} /> : <ForgotPassword history={history} />}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default AuthPage;